import styled from "styled-components";

export const MusicHallDetailContainerStyled = styled.div`
  background-color: ${({ theme }) => theme.COLORS.WHITE_1};
  .back_bar {
    margin-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* ปุ่มลบ หน้าตาเดียวกับปุ่มกลับ แต่สีแดง (การกระทำที่ย้อนไม่ได้) */
    .delete_wrap {
      display: flex;
      align-items: center;
      column-gap: 10px;
      .delete_hint {
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
    }
    .btn_delete {
      border: 1px solid ${({ theme }) => theme.COLORS.RED_1};
      border-radius: 8px;
      padding: 0 14px 0 10px;
      height: 36px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      column-gap: 4px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      line-height: 1;
      cursor: pointer;
      transition: 0.2s;
      &:hover {
        background: ${({ theme }) => theme.COLORS.RED_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
      }
      &.disabled {
        border-color: ${({ theme }) => theme.COLORS.GRAY_1};
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        cursor: not-allowed;
        &:hover {
          background: ${({ theme }) => theme.COLORS.WHITE_1};
        }
      }
    }
    /* หน้าตาเดียวกับปุ่ม Edit/Action (ขอบเทา มุม 8px) ให้กลืนกับปุ่มอื่นในหน้า */
    .btn_back {
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
      border-radius: 8px;
      padding: 0 16px 0 8px;
      height: 36px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      column-gap: 2px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      line-height: 1;
      cursor: pointer;
      transition: 0.2s;
      .btn_back_icon {
        flex-shrink: 0;
      }
      &:hover {
        border-color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }
  .booking_step_layout {
    margin-bottom: 20px;
    padding-left: 20px;
  }
  .sec_layout {
    margin-bottom: 26px;
    border-bottom: 1px solid Black;
    padding-left: 20px;
    padding-right: 20px;
    &.no_border {
      border-bottom: none;
    }
    .title {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .detail_row {
      display: flex;
      flex-wrap: wrap;
      column-gap: 40px;
      .detail_col {
        flex: 1;
        min-width: 360px;
      }
      /* หน้า detail ตัวใหญ่กว่าการ์ดปกติ 2px (popup ชำระเงินใช้การ์ดเดียวกันแต่คงขนาดเดิม) */
      .room_info_row .room_info_head,
      .room_info_row .room_info_detail,
      .customer_info_row .customer_info_head,
      .customer_info_row .customer_info_detail {
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      }
    }
  }
`;
